export default __webpack_public_path__ + "static/media/tutorial5-2.e42c53a6.png";